<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-para">To Patricia McGowan.<br/>She is the teacher who saw more in me than I saw in myself.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm02.vue?42ea2d0d